export const B_BG = 'bBg';
export const FG_RADIUS = 'fgradius';
